import { Dispatch } from 'redux';
import * as React from 'react';
import { AxiosError } from 'axios';
import { authService } from '@app/services';
import { responseOnSuccess } from '@app/modules/mfaToken/helpers';
import { parseString } from '@app/helpers';

export const handleChangeInputOtp = (
    setOtpCode: React.Dispatch<string>,
    setIsError: React.Dispatch<boolean>,
    isError: boolean
) => (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isError) {
        setIsError(false);
    }
    setOtpCode(e.target.value);
};

export const onSubmitOtp = (
    dispatch: Dispatch,
    context: string,
    setIsLoggingIn: React.Dispatch<boolean>,
    rememberMe?: boolean
) => (otpCode: string, setIsError: React.Dispatch<boolean>) => (
    e: React.ChangeEvent<HTMLFormElement>
) => {
    e.preventDefault();
    setIsLoggingIn(true);
    return authService
        .signInOtp(context, otpCode)
        .then(responseOnSuccess(dispatch, rememberMe))
        .catch(() => {
            setIsError(true);
            setIsLoggingIn(false);
        });
};

export const getContextToken = (error: AxiosError<any>) => {
    const errorUri = error?.response?.data?.error_uri ?? '';
    const { context } = parseString(window.atob(errorUri));

    return context;
};
